<template>
    <div class="biz-task-payment-comp">
        <pay-wallet-detail :walletPaymentInfo="walletPaymentInfo"></pay-wallet-detail>
        <toogle-block>
            <div class="toogle-title" slot="toogle-title">
                受託人確認
            </div>
            <div class="toogle-body" slot="toogle-body">
                <div class="biz-table">
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                            房源名稱
                        </div>
                        <div class="biz-table-content">
                            {{paymentInfo.houseName}}
                        </div>
                    </div>
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                            房源地址
                        </div>
                        <div class="biz-table-content">
                            {{paymentInfo.completeAddress}}
                        </div>
                    </div>
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                            租金
                        </div>
                        <div class="biz-table-content">
                            {{toCurrency(paymentInfo.rentMonthly)}}
                        </div>
                    </div>
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                            受託人姓名
                        </div>
                        <div class="biz-table-content">
                            {{paymentInfo.taskTakerName}}
                        </div>
                    </div>
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                            受託人電話
                        </div>
                        <div class="biz-table-content">
                            {{paymentInfo.taskTakerPhone}}
                        </div>
                    </div>
                </div>
            </div>
        </toogle-block>
        <toogle-block>
            <div class="toogle-title" slot="toogle-title">
                委託設定
            </div>
            <div class="toogle-body" slot="toogle-body">
                <div class="biz-table">
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                            委託獎金
                        </div>
                        <div class="biz-table-content">
                            {{toCurrency(paymentInfo.taskBonus)}}
                        </div>
                    </div>
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                            業務
                        </div>
                        <div class="biz-table-content">
                            {{paymentInfo.agentName}}
                        </div>
                    </div>
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                            委託開始時間
                        </div>
                        <div class="biz-table-content">
                            {{getFormatDateTime(paymentInfo.taskBeginTime)}}
                        </div>
                    </div>
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                            委託結束時間
                        </div>
                        <div class="biz-table-content">
                            {{getFormatDateTime(paymentInfo.taskEndTime)}}
                        </div>
                    </div>
                </div>
            </div>
        </toogle-block>
        <toogle-block>
            <div class="toogle-title" slot="toogle-title">
                支付獎金方式
            </div>
            <div class="toogle-body virtual" slot="toogle-body">
                <div class="pay-types">
                    <!-- <div class="type atm" :class="{'active': payType==0}" @click="payType=0, balanceNotEnough = ''">
                        <img v-if="payType==0" src="@/assets/img/icon/atm_orange.svg" alt="" srcset="">
                        <img v-else src="@/assets/img/icon/atm_gray.svg" alt="" srcset="">
                        <div class="content-wrap">
                            <div class="title">
                                匯款帳號
                            </div>
                        </div>
                    </div> -->
                    <div class="type wallet" :class="{'active': payType==1}" >
                        <img v-if="payType==1" src="@/assets/img/icon/wallet_orange.svg" alt="" srcset="">
                        <img v-else src="@/assets/img/icon/wallet_gray.svg" alt="" srcset="">
                        <div class="content-wrap">
                            <div class="title">
                                飛豬錢包
                            </div>
                            <div class="description">
                                錢包餘額：{{toCurrency(userBalance)}}
                            </div>
                        </div>
                    </div>
                    <span class="balance-not-enough" v-if="balanceNotEnough">
                        <img src="@/assets/img/icon/alarm_msg_error.svg" alt="">
                        {{balanceNotEnough}}
                    </span>
                </div>
                <div v-if="payType!=null" class="confirm-info">
                    <!-- <h2>確認資訊</h2> -->
                    <div class="content">
                        <div class="list">
                            <span class="title">付款方式</span>
                            <span class="info">：{{paymentInfo.payway}}</span>
                        </div>
                        <div class="list">
                            <span class="title">扣款項目</span>
                            <span class="info">：委託獎金</span>
                        </div>
                        <div class="list">
                            <span class="title">扣款金額</span>
                            <span class="info" :class="{'warm': !paymentInfo.taskBonus}">：{{toCurrency(paymentInfo.taskBonus)}}</span>
                        </div>
                    </div>
                    <button class="default-button" :disabled="disabledState" @click="payment()">確定使用飛豬錢包付款</button>
                </div>
            </div>
        </toogle-block>
    </div>
</template>
<script>
import toogleBlock from '@/components/bussiness/widges/tools/toogleBlock.vue';
import payWalletDetail from '@/components/bussiness/widges/modals/payWalletDetail.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            payType: 1,
            balanceNotEnough: null,
            walletPaymentInfo: null,
            disabledState: false,
        }
    },
    mounted () {
        if(this.paymentInfo == null){
            this.$router.push({name: 'bizTaskMgtDefault', hash: '#待付款'})
            this.$store.dispatch('setAlarmStatus', {status: true,title: '請重新選擇付款委託',type: 'error'})
        }
        this.$store.dispatch('getUserBalance')
        .then(()=>{
            this.checkBalance()
        })
    },
    methods: {
        checkBalance: function () {
            if(this.paymentInfo.taskBonus == null){
                this.payType = 1
            }else if(parseFloat(this.userBalance) > parseFloat(this.paymentInfo.taskBonus)){
                this.balanceNotEnough = ''
                this.payType = 1
            }else{
                this.balanceNotEnough = '餘額不足'
                this.payType = null
            }
        },
        payment: function () {
            this.disabledState = true
            let data = {
                paymentType: 'HOUSE_TASK_BONUS',
                referenceSeq: this.paymentInfo.taskSeq
            }
            this.$store.dispatch('bizWalletPayment', data)
            .then((res)=>{
                this.disabledState = false
                this.$analyticsBiz.logEvent('飛豬錢包付款', { screen_name: '飛豬錢包付款'})
                this.walletPaymentInfo = res
                this.$store.dispatch('setModalStatus', {state: true, type: 'bizPayWalletDetail'})
            })
            .catch(() => {
                this.disabledState = false
                this.$store.dispatch('setAlarmStatus', {status: true,title: '飛豬錢包扣款失敗',type: 'error'})
            })
        }
    },
    computed: {
        ...mapGetters({
            userBalance: 'GET_USER_BALANCE',
            paymentInfo: 'GET_BIZ_TASK_PAYMENT_INFO',
        })
    },
    components: {
        toogleBlock,
        payWalletDetail
    },
}
</script>
<style lang="scss" scoped>
    .biz-task-payment-comp{
        .biz-table-row{
            .biz-table-title{
                width: 84px;
                padding-right: 16px;
            }
        }
        .virtual{
                // display: flex;
                // flex-direction: column;
                .pay-types{
                    display: flex;
                    flex-direction: column;
                    width: 220px;
                    justify-content: center;
                    align-items: center;
                    .type{
                        position: relative;
                        display: flex;
                        align-items: center;
                        padding: 0 20px;
                        height: 90px;
                        border-radius: 4px;
                        border: solid 1px #c5c2c1;
                        background-color: #fff;
                        line-height: 1.71;
                        color: #a8a5a4;
                        margin-right: 16px;
                        cursor: pointer;
                        img{
                            margin-right: 10px;
                        }
                        .content-wrap{
                            .description{
                                font-size: 12px;
                            }
                        }
                    }
                    .type.active{
                        border: solid 1px #ff9275;
                        background-color: #fff;
                        color: #ff9275;
                    }
                    .atm{
                        width: 121px;
                    }
                    .wallet{
                        min-width: 166px;
                    }
                    .balance-not-enough{
                        position: relative;
                        font-size: 16px;
                        font-weight: 500;
                        color: #fc7171;
                        display: flex;
                        align-items: center;
                        bottom: -5px;
                        img{ 
                            margin-right: 8px;
                            width: 16px;
                        }
                    }
                }
                .confirm-info{
                    // width: 1094px;
                    // height: 428px;
                    // padding: 24px 30px;
                    // border: solid 1px #f3f3f3;
                    // border-radius: 8px;
                    background-color: #fff;
                    margin-top: 28px;
                    h2{
                        font-size: 20px;
                        margin-bottom: 20px;
                    }
                    .content{
                        margin-bottom: 20px;
                        .list{
                            display: flex;
                            margin-bottom: 16px;
                            .title{
                                display: block;
                                width: 56px;
                            }
                        }
                        .warm{
                            color: #fc7171;
                        }
                    }
                    .default-button{
                        width: 200px;
                    }
                }
            }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/taskMgt/taskPayment/taskPaymentComp.vue